import { TaikhoanmymobiService } from 'src/services/taikhoanmymobi.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const TAIKHOANMYMOBI_NEW_CARE_SUCCESS = 'TAIKHOANMYMOBI:NEW_CARE_SUCCESS'
export const TAIKHOANMYMOBI_LIST_SUCCESS = 'TAIKHOANMYMOBI:FIND_ALL_SUCCESS'
export const TAIKHOANMYMOBI_LIST_FAILD = 'TAIKHOANMYMOBI:FIND_ALL_FAILD'
export const TAIKHOANMYMOBI_COUNT_ASSIGN_SUCCESS = 'TAIKHOANMYMOBI:COUNT_ASSIGN_SUCCESS'
export const TAIKHOANMYMOBI_COUNT_ASSIGN_FAILD = 'TAIKHOANMYMOBI:COUNT_ASSIGN_FAILD'

export const TAIKHOANMYMOBI_CREATE_SUCCESS = 'TAIKHOANMYMOBI:CREATE_SUCCESS'
export const TAIKHOANMYMOBI_CREATE_FAILD = 'TAIKHOANMYMOBI:CREATE_FAILD'

export const TAIKHOANMYMOBI_IMPORT_SUCCESS = 'TAIKHOANMYMOBI:IMPORT_SUCCESS'
export const TAIKHOANMYMOBI_SAVE_SUCCESS = 'TAIKHOANMYMOBI:SAVE_SUCCESS'
export const TAIKHOANMYMOBI_SAVE_FAILD = 'TAIKHOANMYMOBI:SAVE_SUCCESS'

export const TAIKHOANMYMOBI_DEL_SUCCESS = 'TAIKHOANMYMOBI:DEL_SUCCESS'
export const TAIKHOANMYMOBI_DEL_FAILD = 'TAIKHOANMYMOBI:DEL_FAILD'

export const TAIKHOANMYMOBI_ONE_SUCCESS = 'TAIKHOANMYMOBI:FIND_ONE_SUCCESS'
export const TAIKHOANMYMOBI_ONE_FAILD = 'TAIKHOANMYMOBI:FIND_ONE_FAILD'

export const TAIKHOANMYMOBI_HISTORY_LIST_SUCCESS = 'TAIKHOANMYMOBI:HISTORY_FIND_ALL_SUCCESS'
export const TAIKHOANMYMOBI_HISTORY_LIST_FAILD = 'TAIKHOANMYMOBI:HISTORY_FIND_ALL_FAILD'

export const TAIKHOANMYMOBI_UPDATE_FILTER = 'TAIKHOANMYMOBI:UPDATE_FILTER'

export const TAIKHOANMYMOBICOMLIST_LIST_SUCCESS = 'TAIKHOANMYMOBICOMLIST:FIND_ALL_SUCCESS'
export const TAIKHOANMYMOBICOMLIST_LIST_FAILD = 'TAIKHOANMYMOBICOMLIST:FIND_ALL_FAILD'

export const TaikhoanmymobiAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    updateFilter,
    batTatLoaiDichVu,
    xoaMucDaChon,
    findAllByOrder,
}

function updateFilter(payload) {
    return { type: TAIKHOANMYMOBI_UPDATE_FILTER, data: payload }
}

function batTatLoaiDichVu(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            TaikhoanmymobiService.batTatLoaiDichVu(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(TaikhoanmymobiAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: TAIKHOANMYMOBI_CREATE_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_CREATE_FAILD, error } }
}

function xoaMucDaChon(payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            TaikhoanmymobiService.xoaMucDaChon(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(TaikhoanmymobiAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: TAIKHOANMYMOBI_CREATE_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_CREATE_FAILD, error } }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            TaikhoanmymobiService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(TaikhoanmymobiAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: TAIKHOANMYMOBI_CREATE_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        TaikhoanmymobiService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: TAIKHOANMYMOBI_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { taikhoanmymobi } = getState()
        dispatch(AppAction.appLoading(true));
        TaikhoanmymobiService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...taikhoanmymobi.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: TAIKHOANMYMOBI_LIST_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_LIST_FAILD, error } }
}

function findAllByOrder(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { taikhoanmymobi } = getState();
        const page = taikhoanmymobi && typeof taikhoanmymobi.filter !== 'undefined' && taikhoanmymobi.filter && typeof taikhoanmymobi.filter.page !== 'undefined' ? taikhoanmymobi.filter.page : 0;
        const limit = taikhoanmymobi && typeof taikhoanmymobi.filter !== 'undefined' && taikhoanmymobi.filter && typeof taikhoanmymobi.filter.limit !== 'undefined' ? taikhoanmymobi.filter.limit : 10;
        TaikhoanmymobiService.findAllByOrder(id, page, limit, taikhoanmymobi.filter).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                const oldItems = taikhoanmymobi.taikhoanmymobicomlist_items;
                const rsDataValues = rs.data.values;

                var uniqueItems = oldItems;
                for (var i = limit * page; i < limit * page + limit; i++) {
                    if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                        uniqueItems[i] = rsDataValues[i - limit * page];
                    } else if (typeof uniqueItems[i] !== 'undefined') {
                        delete uniqueItems[i];
                    }
                }
                
                console.log({
                    items: uniqueItems,
                    total: rs.data.count
                })
                dispatch(success({
                    items: uniqueItems,
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: TAIKHOANMYMOBICOMLIST_LIST_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBICOMLIST_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { taikhoanmymobi } = getState();
        const page = taikhoanmymobi && typeof taikhoanmymobi.filter !== 'undefined' && taikhoanmymobi.filter && typeof taikhoanmymobi.filter.page !== 'undefined' ? taikhoanmymobi.filter.page : 0;
        const limit = taikhoanmymobi && typeof taikhoanmymobi.filter !== 'undefined' && taikhoanmymobi.filter && typeof taikhoanmymobi.filter.limit !== 'undefined' ? taikhoanmymobi.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            TaikhoanmymobiService.findAll(page, limit, taikhoanmymobi.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count
                    }));
                } else {
                    const oldItems = taikhoanmymobi.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count
                    }));
                }

                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: TAIKHOANMYMOBI_LIST_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: TAIKHOANMYMOBI_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            TaikhoanmymobiService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(TaikhoanmymobiAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: TAIKHOANMYMOBI_SAVE_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            TaikhoanmymobiService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(TaikhoanmymobiAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: TAIKHOANMYMOBI_CREATE_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        TaikhoanmymobiService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(TaikhoanmymobiAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: TAIKHOANMYMOBI_CREATE_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        TaikhoanmymobiService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(TaikhoanmymobiAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: TAIKHOANMYMOBI_DEL_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        TaikhoanmymobiService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: TAIKHOANMYMOBI_ONE_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        TaikhoanmymobiService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(TaikhoanmymobiAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { taikhoanmymobi } = getState()
        dispatch(AppAction.appLoading(true));
        TaikhoanmymobiService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...taikhoanmymobi.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: TAIKHOANMYMOBI_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: TAIKHOANMYMOBI_HISTORY_LIST_FAILD, error } }
}